import type {
  ExamQuestion,
  SimuladoSourceQuestion,
} from '@/modules/simulado/domain/entities/question.entity';

export interface OfficialExamDatasource {
  getQuestions(templateId: string): Promise<ExamQuestion[]>;
}

export class OfficialExamRepositoryImpl {
  private readonly datasource: OfficialExamDatasource;

  constructor(datasource: OfficialExamDatasource) {
    this.datasource = datasource;
  }

  /**
   * As questões da prova oficial, na ordem e na numeração dela — é a mesma
   * numeração da folha do gabarito. Questão sem `number` fica com a posição na
   * resposta, e discursiva sai (não tem alternativa a corrigir).
   */
  async getQuestions(templateId: string): Promise<SimuladoSourceQuestion[]> {
    const questions = await this.datasource.getQuestions(templateId);
    return questions
      .filter((question) => !question.isEssay)
      .map((question, index) => ({
        ...question,
        number: question.number ?? index + 1,
      }))
      .sort((a, b) => a.number - b.number);
  }
}
